/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewPrivacyCookieCompliance } from './CRSFSecReviewPrivacyCookieCompliance';
import {
    CRSFSecReviewPrivacyCookieComplianceFromJSON,
    CRSFSecReviewPrivacyCookieComplianceFromJSONTyped,
    CRSFSecReviewPrivacyCookieComplianceToJSON,
} from './CRSFSecReviewPrivacyCookieCompliance';

/**
 * 
 * @export
 * @interface CRSFSecReviewPrivacyTechnologiesResult
 */
export interface CRSFSecReviewPrivacyTechnologiesResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewPrivacyTechnologiesResult
     */
    advertising: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewPrivacyTechnologiesResult
     */
    analytics: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewPrivacyTechnologiesResult
     */
    chatbot: Array<string>;
    /**
     * 
     * @type {Array<CRSFSecReviewPrivacyCookieCompliance>}
     * @memberof CRSFSecReviewPrivacyTechnologiesResult
     */
    cookie_compliance: Array<CRSFSecReviewPrivacyCookieCompliance>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewPrivacyTechnologiesResult
     */
    fingerprinting: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewPrivacyTechnologiesResult
     */
    geolocation: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewPrivacyTechnologiesResult
     */
    tag_manager: Array<string>;
}

/**
 * Check if a given object implements the CRSFSecReviewPrivacyTechnologiesResult interface.
 */
export function instanceOfCRSFSecReviewPrivacyTechnologiesResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "advertising" in value;
    isInstance = isInstance && "analytics" in value;
    isInstance = isInstance && "chatbot" in value;
    isInstance = isInstance && "cookie_compliance" in value;
    isInstance = isInstance && "fingerprinting" in value;
    isInstance = isInstance && "geolocation" in value;
    isInstance = isInstance && "tag_manager" in value;

    return isInstance;
}

export function CRSFSecReviewPrivacyTechnologiesResultFromJSON(json: any): CRSFSecReviewPrivacyTechnologiesResult {
    return CRSFSecReviewPrivacyTechnologiesResultFromJSONTyped(json, false);
}

export function CRSFSecReviewPrivacyTechnologiesResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewPrivacyTechnologiesResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'advertising': json['advertising'],
        'analytics': json['analytics'],
        'chatbot': json['chatbot'],
        'cookie_compliance': ((json['cookie_compliance'] as Array<any>).map(CRSFSecReviewPrivacyCookieComplianceFromJSON)),
        'fingerprinting': json['fingerprinting'],
        'geolocation': json['geolocation'],
        'tag_manager': json['tag_manager'],
    };
}

export function CRSFSecReviewPrivacyTechnologiesResultToJSON(value?: CRSFSecReviewPrivacyTechnologiesResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'advertising': value.advertising,
        'analytics': value.analytics,
        'chatbot': value.chatbot,
        'cookie_compliance': ((value.cookie_compliance as Array<any>).map(CRSFSecReviewPrivacyCookieComplianceToJSON)),
        'fingerprinting': value.fingerprinting,
        'geolocation': value.geolocation,
        'tag_manager': value.tag_manager,
    };
}

